const template = document.createElement('template');
template.innerHTML = `
  <style>
    :host {
      position: fixed;
      right: 16px;
      bottom: 16px;
      z-index: 1200;
      display: block;
      font-family: inherit;
    }

    .banner {
      display: flex;
      align-items: center;
      gap: 12px;
      max-width: min(420px, calc(100vw - 32px));
      padding: 14px 16px;
      border: 1px solid #f0e1c6;
      border-radius: 8px;
      background: rgba(255, 255, 255, 0.96);
      box-shadow: 0 0px 12px rgba(33, 24, 16, 0.16);
      opacity: 0;
      transform: translateY(20px);
      pointer-events: none;
      transition: opacity 220ms ease, transform 220ms ease;
    }

    .banner.is-visible {
      opacity: 1;
      transform: translateY(0);
      pointer-events: auto;
    }

    .banner.is-dismissed {
      display: none;
    }

    .content {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 10px;
    }

    .content p {
      margin: 0;
      color: #2d241f;
      font-size: 14px;
      line-height: 1.4;
    }

    .button {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 8px 12px;
      border-radius: 999px;
      background: #f2618b;
      color: #ffffff;
      font-size: 13px;
      font-weight: 800;
      text-decoration: none;
    }

    .close {
      border: 0;
      background: transparent;
      color: #2d241f;
      cursor: pointer;
      font-size: 22px;
      line-height: 1;
    }

    .badge {
      position: fixed;
      left: -10px;
      bottom: 10px;
      z-index: 1100;
      display: none;
      width: 48px;
      height: 120px;
      border: 0;
      border-radius: 8px;
      background: #f0f0f0;
      color: #ffffff;
      box-shadow: 0 10px 24px rgba(33, 24, 16, 0.18);
      cursor: pointer;
      font-size: 24px;
      box-shadow: 0 0 2px 2px rgba(0,0,0,0.1);
    }

    .badge.is-visible {
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
  </style>

  <div class="banner" part="banner" aria-hidden="true">
    <div class="content">
      <slot>
        <p>Du willst mal kurz abschalten? <strong>Lust auf ein Spiel?</strong></p>
        <a class="button" href="/spiele.html" target="_self" rel="noopener">Lust auf ein Spiel?</a>
      </slot>
    </div>
    <button class="close" type="button" part="close" aria-label="Banner schließen">×</button>
  </div>

  <button class="badge" type="button" part="badge" aria-label="Banner wieder öffnen">⚡</button>
`;

class FooterBanner extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.shadowRoot.appendChild(template.content.cloneNode(true));

    this.banner = this.shadowRoot.querySelector('.banner');
    this.badge = this.shadowRoot.querySelector('.badge');
    this.closeButton = this.shadowRoot.querySelector('.close');

    this.showBanner = this.showBanner.bind(this);
    this.hideBanner = this.hideBanner.bind(this);
  }

  connectedCallback() {
    this.closeButton.addEventListener('click', this.hideBanner);
    this.badge.addEventListener('click', this.showBanner);

    const randomDelay = 2000 + Math.floor(Math.random() * 5000);

    window.setTimeout(() => {
      requestAnimationFrame(() => {
        this.showBanner();
      });
    }, 100);
  }

  disconnectedCallback() {
    this.closeButton.removeEventListener('click', this.hideBanner);
    this.badge.removeEventListener('click', this.showBanner);
  }

  showBanner() {
    this.banner.classList.add('is-visible');
    this.banner.classList.remove('is-dismissed');
    this.banner.setAttribute('aria-hidden', 'false');
    this.badge.classList.remove('is-visible');
  }

  hideBanner() {
    this.banner.classList.remove('is-visible');
    this.banner.classList.add('is-dismissed');
    this.banner.setAttribute('aria-hidden', 'true');
    this.badge.classList.add('is-visible');
  }
}

if (!customElements.get('footer-banner')) {
  customElements.define('footer-banner', FooterBanner);
}
